import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3458063c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "companies-list-card card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = {
  key: 0,
  class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
    href: "#",
    "data-bs-toggle": "modal",
    "data-bs-target": "#CreateCompanyModal"
  }, [
    /*#__PURE__*/_createTextVNode(" Criar nova instalação "),
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" })
  ])
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "companies-list-body card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_6 = { class: "companies-table-wrapper table-responsive" }
const _hoisted_7 = { class: "companies-table table text-nowrap align-middle mb-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " CPF/CNPJ "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Telefone "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Detalhes ")
  ])
], -1))
const _hoisted_9 = {
  class: "company-name-cell shadow-none lh-1 fw-medium text-black-emphasis title ps-0",
  "data-label": "Nome"
}
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_12 = {
  class: "company-detail-cell shadow-none lh-1 fw-medium text-black-emphasis",
  "data-label": "CPF/CNPJ"
}
const _hoisted_13 = {
  class: "company-detail-cell shadow-none lh-1 fw-medium text-black-emphasis",
  "data-label": "Telefone"
}
const _hoisted_14 = {
  class: "company-detail-cell company-status-cell shadow-none lh-1 fw-medium text-black-emphasis",
  "data-label": "Status"
}
const _hoisted_15 = {
  class: "company-action-cell shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0 d-flex justify-content-end",
  "data-label": "Detalhes"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit position-relative fs-16 d-flex lh-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteCompanyModal = _resolveComponent("DeleteCompanyModal")!
  const _component_CreateCompanyModal = _resolveComponent("CreateCompanyModal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteCompanyModal),
    _createVNode(_component_CreateCompanyModal),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.getConfigurations.adm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsersList, (value, key) => {
                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                  _createElementVNode("th", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(value.installation_name), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.applyMaskCpfCnpj(value.cpf_cnpj)), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.applyMaskPhone(value.installation_commercial_phone_01)), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(value.active == 1 ? 'Ativo' : 'Inativo'), 1),
                  _createElementVNode("td", _hoisted_15, [
                    _createVNode(_component_router_link, {
                      to: '/installation/'+value.installation_id,
                      class: "company-details-button position-relative transition border-0 fw-medium text-white p-10 rounded-1 bg-info d-flex text-decoration-none fit-content",
                      "aria-label": `Ver detalhes de ${value.installation_name}`,
                      title: `Ver detalhes de ${value.installation_name}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["to", "aria-label", "title"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}